<script setup lang="ts">
import { onMounted } from 'vue';
import { useAuthStore } from './stores/auth';
import { useThemeStore } from './stores/theme';

const auth = useAuthStore();
const theme = useThemeStore();

onMounted(async () => {
  theme.init();
});
</script>

<template>
  <router-view />
</template>
